// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oYY9","icon":"styles_icon__2ujf5"};